import { useRequest } from '@fuxi/eevee-hooks';
import { get } from 'lodash-es';
import { MonorepoType } from '@yaotai/common-utils';
import { SwitchConfItem } from '../constants';
import { CommonAPI } from '../services';

export function useAntiSpamFeatureSwitch({ monorepoType, aid }: { aid?: string; monorepoType?: MonorepoType }) {
  const { data, loading, run } = useRequest(
    aid => {
      return CommonAPI.current!.activity!.getActivityAntiSpamStatus(aid);
    },
    {
      manual: true,
    },
  );

  const switchConf = get(data, 'data', {}) as { [key: string]: SwitchConfItem };

  return {
    switchConf,
    isGettingSwitchConfig: loading,
    refetchAntiSampleStatus: run,
  };
}
